module.exports = __webpack_public_path__ + "static/jazper-6ea1a424cae7d46510e295c0a1ca926c.png";